import { ROUTE_LOGIN } from "../../resources/routes-name";
import { ROUTES_ROLE } from "../../resources/routes-role";
import { GET, GET_CHANGE_DEVICE, GET_PROFILE, LOGIN_GOOGLE, POST } from "../../services";
import { windowNavigateReplaceTo } from "../../utils/navigation/navigation-services";
import { getAuthToken } from "../../utils/storage/storage";

interface IUserAuthLoginGoogle {
  auth?: string;
}

export const userAuthCurrent = async () => {
  try {
    const accessToken = getAuthToken();
    const res = await GET(GET_PROFILE, accessToken);
    if (!res.success) {
      throw new Error("get profile error");
    }
    const resChange = await GET(GET_CHANGE_DEVICE)
    const { role } = res.result.user;
    const menu = ROUTES_ROLE[role as keyof typeof ROUTES_ROLE] || [];

    return {
      ...res.result,
      ...resChange.result,
      menu,
    };
  } catch (error) {
    console.log(error);
    windowNavigateReplaceTo({ pathname: ROUTE_LOGIN });
  }
};

export const userAuthLoginGoogle = async ({ auth }: IUserAuthLoginGoogle) => {
  return await POST(LOGIN_GOOGLE, { auth });
};
